import { Box, Button, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { InputKit } from '../../components/UI';
import { AuthService } from '../../Service/AuthService';
import { LocalStorageService } from '../../Service/LocalStorageService';
import { useAppDispatch } from '../../store/hooks';
import { setAuthUser, setToken } from '../../store/user/user-slice';
export interface IFormInput {
  email: string;
  password: string;
}

const AdminLogin = () => {
  const appDispatch = useAppDispatch();
  const methods = useForm<IFormInput>();
  const { handleSubmit, setError } = methods;

  const navigate = useNavigate();

  const loginUser = async (values: IFormInput) => {
    try {
      const response = await AuthService.login(values.email, values.password);
      LocalStorageService.setItem('accessToken', response.data.accessToken);
      LocalStorageService.setItem('role', response.data.role);
      appDispatch(setToken(response.data.accessToken));
      appDispatch(setAuthUser(response.data));

      navigate('/admin');
    } catch (error: any) {
      if (
        error.message === 'Password is incorrect!' &&
        error.statusCode === 401
      ) {
        setError('password', {
          type: 'required',
          message: 'Password is incorrect!',
        });
      } else if (
        error.message === 'Email does not exist!' &&
        error.statusCode === 401
      ) {
        setError('email', {
          type: 'required',
          message: 'Email does not exist!',
        });
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <Box
        sx={{
          maxWidth: '100%',
          width: '100%',
          display: 'flex',
          padding: '20px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <form
          action='submit'
          style={{
            maxWidth: '472px',
            width: '100%',
          }}
        >
          <Box
            bgcolor={'#fff'}
            display={'flex'}
            flexDirection={'column'}
            p={'24px'}
            sx={{ boxShadow: '0px 2px 20px  rgba(29, 49, 55, 0.12)' }}
            borderRadius={'4px'}
            gap={'24px'}
          >
            <Typography variant='h1'>Log in</Typography>
            <InputKit
              name={'email'}
              placeholder={'Email'}
              type='email'
              validation={{
                required: {
                  value: true,
                  message: 'Email is required',
                },
              }}
            />
            <InputKit
              name={'password'}
              type={'password'}
              placeholder='Password'
              validation={{
                required: {
                  value: true,
                  message: 'Password is required',
                },
                minLength: {
                  value: 8,
                  message: 'Password must have at least 8 characters',
                },
              }}
              sxStyle={{
                width: '100%',
              }}
            />

            <Button
              sx={{
                background: '#3293DB',
                color: '#fff',
                maxWidth: '100%',
                boxShadow: 'unset',
                fontSize: '14px',
                lineHeight: '17px',
              }}
              onClick={handleSubmit(loginUser)}
              type='submit'
              variant='contained'
            >
              Log In
            </Button>
          </Box>
        </form>
      </Box>
    </FormProvider>
  );
};

export default AdminLogin;
